<template>
  <div class="health-dashboard">
    <!-- 顶部筛选器 + Tabs 同行 -->
    <div class="header-wrapper">
      <el-tabs v-model="activeTab" class="dashboard-tabs" @tab-click="handleTabClick">
        <el-tab-pane label="数据看板" name="dashboard"></el-tab-pane>
        <el-tab-pane label="患者列表" name="patientList"></el-tab-pane>
      </el-tabs>
      <div class="filter-right">
        <el-select v-model="timePreset" placeholder="选择时间段" size="small" @change="handleTimePresetChange" style="width: 120px; margin-right: 12px;">
          <el-option label="一周前" value="7d"></el-option>
          <el-option label="一月前" value="30d"></el-option>
          <el-option label="三月前" value="90d"></el-option>
          <el-option label="现在" value="0d"></el-option>
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          size="small"
          style="width: 260px;"
          @change="handleDateRangeChange"
        ></el-date-picker>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="tab-content-wrapper">
      <!-- 数据看板 -->
      <div v-show="activeTab === 'dashboard'" class="tab-content dashboard-content" v-loading="dashboardLoading" element-loading-text="数据加载中...">
        <!-- 上：统计卡片 -->
        <div class="section-top">
          <el-row :gutter="16" class="stat-cards-row" style="height:100%;">
            <el-col :span="6" style="height:100%;">
              <div class="stat-card clickable-card" @click="handleTotalPatientsClick">
                <div class="stat-card-label">①总患者数</div>
                <div class="stat-card-value">{{ statData.totalPatients || 0 }}</div>
                <div class="stat-card-trend">
                  <span :class="statData.totalGrowth >= 0 ? 'trend-up' : 'trend-down'">
                    环比 {{ statData.totalGrowth >= 0 ? '+' : '' }}{{ statData.totalGrowth }}%
                    <i :class="statData.totalGrowth >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                  </span>
                </div>
              </div>
            </el-col>
            <el-col :span="6" style="height:100%;">
              <div class="stat-card clickable-card" @click="handleMonthlyNewClick">
                <div class="stat-card-label">②月新增患者</div>
                <div class="stat-card-value">{{ statData.monthlyNew || 0 }}</div>
                <div class="stat-card-trend">
                  <span :class="statData.monthlyGrowth >= 0 ? 'trend-up' : 'trend-down'">
                    环比 {{ statData.monthlyGrowth >= 0 ? '+' : '' }}{{ statData.monthlyGrowth }}%
                    <i :class="statData.monthlyGrowth >= 0 ? 'el-icon-top' : 'el-icon-bottom'"></i>
                  </span>
                </div>
              </div>
            </el-col>
            <el-col :span="6" style="height:100%;">
              <div class="stat-card">
                <div class="stat-card-label">③关注患者数</div>
                <div class="stat-card-value">{{ statData.followedPatients || 0 }}</div>
                <div class="stat-card-trend"><span class="trend-up">环比 +3.1% ↑</span></div>
              </div>
            </el-col>
            <el-col :span="6" style="height:100%;">
              <div class="stat-card">
                <div class="stat-card-label">④月就诊人次</div>
                <div class="stat-card-value">{{ statData.monthlyVisits || 0 }}</div>
                <div class="stat-card-trend"><span class="trend-up">环比 +1.8% ↑</span></div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 中：四个盒子（复诊率改为折线图+进度条，年龄分布改为折线图） -->
        <div class="section-middle">
          <div class="middle-grid">
            <!-- 盒子1：运营转化 + 平均客单价 -->
            <div class="chart-card hover-card">
              <div class="card-top" style="flex: 0 0 70%;">
                <div class="chart-card-title">运营转化</div>
                <div v-if="chartReady" class="chart-container" id="conversionChart"></div>
              </div>
              <div class="card-bottom" style="flex: 0 0 30%;">
                <div class="footer-left">
                  <div class="footer-label">平均客单价</div>
                  <div class="footer-value">¥{{ statData.averageCustomerSpend || 0 }}</div>
                  <div class="footer-trend trend-up">环比 +71.26% ↑</div>
                </div>
              </div>
            </div>

            <!-- 盒子2：复诊率（折线图 + 进度条） -->
            <div class="chart-card hover-card">
              <div class="card-top" style="flex: 0 0 100%; display: flex; flex-direction: column; padding: 0;">
                <div class="chart-card-title" style="padding: 4px 8px 0;">复诊率</div>
                <div style="flex: 0 0 90%; min-height: 0; position: relative;">
                  <div v-if="chartReady" class="chart-container" id="revisitRateChart"></div>
                </div>
                <div style="flex: 0 0 10%; min-height: 0; display: flex; align-items: center; padding: 0 8px 4px;">
                  <el-progress :percentage="statData.revisitRate || 0" :stroke-width="8" color="#1677FF" :format="p => p + '%'"></el-progress>
                </div>
              </div>
            </div>

            <!-- 盒子3：接诊医生TOP5 -->
            <div class="chart-card hover-card">
              <div class="card-top" style="flex: 0 0 100%;">
                <div class="chart-card-title">接诊医生TOP5</div>
                <div v-if="chartReady" class="chart-container" id="doctorChart"></div>
              </div>
            </div>

            <!-- 盒子4：年龄分布（折线图） -->
            <div class="chart-card hover-card">
              <div class="card-top" style="flex: 0 0 100%;">
                <div class="chart-card-title">年龄分布</div>
                <div v-if="chartReady" class="chart-container" id="ageChart"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 下：营收类型占比 + 标频药TOP10 / 高频处置项目TOP10 / 平均客单价 -->
        <div class="section-bottom">
          <el-row :gutter="16" class="bottom-row" style="height:100%;">
            <!-- 左侧：营收类型占比（饼图） -->
            <el-col :span="6" style="height:100%;">
              <div class="chart-card hover-card">
                <div class="chart-card-title">营收类型占比</div>
                <div class="revenue-wrapper">
                  <div v-if="chartReady" class="chart-container" id="revenueChart"></div>
                </div>
              </div>
            </el-col>
            <!-- 右侧：三个卡片横向排列 -->
            <el-col :span="18" style="height:100%;">
              <div class="bottom-right-grid">
                <!-- 标频药TOP10 -->
                <div class="chart-card hover-card bottom-sub-card">
                  <div class="chart-card-title" style="font-size:12px; font-weight:500; color:#606266; margin-bottom:2px;">标频药TOP10</div>
                  <div class="progress-list">
                    <div v-for="(item, index) in drugTop10" :key="index" class="progress-item">
                      <el-tooltip :content="item.name" placement="top" effect="dark">
                        <span class="progress-label">{{ item.name }}</span>
                      </el-tooltip>
                      <el-progress :percentage="item.percent" :stroke-width="6" color="#1677FF" :show-text="false"></el-progress>
                      <span class="progress-percent">{{ item.percent }}%</span>
                    </div>
                  </div>
                </div>
                <!-- 高频处置项目TOP10 -->
                <div class="chart-card hover-card bottom-sub-card">
                  <div class="chart-card-title" style="font-size:12px; font-weight:500; color:#606266; margin-bottom:2px;">高频处置项目TOP10</div>
                  <div class="progress-list">
                    <div v-for="(item, index) in treatmentTop10" :key="index" class="progress-item">
                      <el-tooltip :content="item.name" placement="top" effect="dark">
                        <span class="progress-label">{{ item.name }}</span>
                      </el-tooltip>
                      <el-progress :percentage="item.percent" :stroke-width="6" color="#1677FF" :show-text="false"></el-progress>
                      <span class="progress-percent">{{ item.percent }}%</span>
                    </div>
                  </div>
                </div>
                <!-- 平均客单价（折线图+进度条） -->
                <div class="chart-card hover-card bottom-sub-card" style="display: flex; flex-direction: column; padding: 4px 8px;">
                  <div class="chart-card-title" style="font-size:12px; font-weight:500; color:#606266; margin-bottom:2px;">平均客单价</div>
                  <div style="flex: 0 0 90%; min-height: 0; position: relative;">
                    <div v-if="chartReady" class="chart-container" id="avgPriceChart"></div>
                  </div>
                  <div style="flex: 0 0 10%; min-height: 0; display: flex; align-items: center; padding: 0 4px;">
                    <el-progress :percentage="avgPricePercentage" :stroke-width="8" color="#1677FF" :format="() => '¥' + (statData.averageCustomerSpend || 0)"></el-progress>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 患者列表 -->
      <div v-show="activeTab === 'patientList'" class="tab-content patient-list-content">
        <!-- 筛选行 -->
        <div class="filter-row">
          <div class="filter-group">
            <span class="filter-label">时间范围</span>
            <div class="filter-buttons">
              <el-button size="small" :type="timeRange === '3m' ? 'primary' : ''" @click="timeRange = '3m'">近3月</el-button>
              <el-button size="small" :type="timeRange === '1y' ? 'primary' : ''" @click="timeRange = '1y'">过去1年</el-button>
              <el-button size="small" :type="timeRange === '2y' ? 'primary' : ''" @click="timeRange = '2y'">过去2年</el-button>
              <el-button size="small" :type="timeRange === '3y' ? 'primary' : ''" @click="timeRange = '3y'">过去3年</el-button>
            </div>
          </div>
          <div class="filter-group">
            <span class="filter-label">患者类型</span>
            <el-select
              v-model="patientType"
              placeholder="全部"
              size="small"
              style="width:140px"
              clearable
              @change="handleSearch"
              @clear="handleSearch"
            >
              <el-option label="普通患者" :value="1"></el-option>
              <el-option label="核心患者" :value="2"></el-option>
              <el-option label="重点患者" :value="3"></el-option>
              <el-option label="流失核心患者" :value="4"></el-option>
            </el-select>
          </div>
          <div class="filter-group search-group">
            <el-input v-model="searchName" placeholder="输入姓名/ID搜索" size="small" style="width:160px" clearable @keyup.enter.native="handleSearch"></el-input>
            <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
            <el-button size="small" type="success" @click="handleExport" v-if="$store.getters.hasPermission('system:docphr:export')">导出Excel</el-button>
            <el-button size="small" type="primary" @click="handleAddPatient" v-if="$store.getters.hasPermission('system:docphr:add')">新增患者</el-button>
          </div>
        </div>
        <div class="filter-area">
          <div class="filter-left">
            <span class="filter-title">患者列表：</span>
            <span class="filter-summary">{{ filterSummary }}</span>
            <el-tag v-if="isMonthlyNewMode" size="small" type="warning" style="margin-left: 12px;">📌 月新增模式 - 高亮当月创建</el-tag>
          </div>
        </div>
        <div class="table-wrapper">
          <el-table
              :data="patientList"
              border
              stripe
              style="width:100%;"
              size="small"
              highlight-current-row
              :height="tableHeight"
              @row-click="handleRowClick"
              ref="patientTable"
              :row-class-name="getRowClassName"
          >
            <el-table-column prop="id" label="患者ID" width="100" align="center" fixed="left"></el-table-column>
            <el-table-column prop="name" label="患者姓名" width="100" align="center"></el-table-column>
            <el-table-column prop="sex" label="性别" width="80" align="center">
              <template slot-scope="scope"><span>{{ scope.row.sex === 1 ? '男' : scope.row.sex === 2 ? '女' : '-' }}</span></template>
            </el-table-column>
            <el-table-column prop="age" label="年龄" width="80" align="center"></el-table-column>
            <el-table-column prop="certno" label="身份证号" width="180" align="center"></el-table-column>
            <el-table-column prop="patId" label="健康卡号" width="120" align="center"></el-table-column>
            <el-table-column prop="tel" label="联系电话" width="120" align="center"></el-table-column>
            <!-- 患者类型（根据 phrType 显示正确的 label） -->
            <el-table-column label="患者类型" width="120" align="center">
              <template slot-scope="scope">
                <el-tag size="small" :type="getPhrTypeTagType(scope.row.phrType)">
                  {{ getPhrTypeLabel(scope.row.phrType) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 累计就诊次数：优先取 visitOverview.completedVisitCount -->
            <el-table-column label="累计就诊次数" width="120" align="center">
              <template slot-scope="scope">
                {{ (scope.row.visitOverview && scope.row.visitOverview.completedVisitCount) || 0 }}
              </template>
            </el-table-column>
            <el-table-column prop="totalAmount" label="累计消费金额" width="140" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建日期" width="180" align="center">
              <template slot-scope="scope">
                {{ scope.row.createTime ? formatDate(scope.row.createTime) : '-' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button type="warning" size="mini" @click.stop="handleViewDetail(scope.row)">详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :current-page="currentPage"
                :page-sizes="[20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalPatient"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 关联信息模态框 -->
    <el-dialog
        :visible.sync="associationDialogVisible"
        width="80%"
        :close-on-click-modal="false"
        @close="handleAssociationClose"
        top="8px"
    >
      <template slot="title">
        <div style="background: #00557f; padding: 8px 12px; margin: -20px -20px 0 -20px; border-radius: 4px 4px 0 0;">
          <span style="font-size: 14px; color: #fff; font-weight: bold;">关联信息</span>
        </div>
      </template>
      <div class="association-container">
        <div style="margin-bottom: 12px; text-align: left;">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddRelationDialog">添加关联</el-button>
        </div>
        <el-table :data="relationData" border stripe size="small" style="width:100%">
          <el-table-column fixed="left" label="#" type="index" width="50" align="center"></el-table-column>
          <el-table-column label="姓名" prop="name" width="100" align="center"></el-table-column>
          <el-table-column label="性别" width="80" align="center">
            <template slot-scope="scope">{{ getSexText(scope.row.sex) }}</template>
          </el-table-column>
          <el-table-column label="联系电话" prop="tel" width="120" align="center"></el-table-column>
          <el-table-column label="证件号码" prop="certNo" width="180" align="center"></el-table-column>
          <el-table-column label="关联档案序号" prop="relationId" width="120" align="center"></el-table-column>
          <el-table-column label="备注" prop="remark" width="150" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200" align="center">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center; gap: 6px; flex-wrap: nowrap;">
                <el-button type="primary" size="mini" @click="handleReRelation(scope.row)" icon="el-icon-refresh">重新关联</el-button>
                <el-button type="danger" size="mini" @click="handleCancelRelation(scope.row)" icon="el-icon-delete">取消关联</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="relationData.length === 0" style="text-align: center; color: #999; padding: 20px;">暂无关联信息，点击上方“添加关联”按钮建立关联。</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="associationDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 添加关联子对话框 -->
    <el-dialog
        :title="relationDialogTitle"
        :visible.sync="addRelationDialogVisible"
        width="900px"
        :before-close="handleRelationDialogClose"
        top="8px"
    >
      <el-form :model="relationForm" ref="relationForm" size="mini" label-width="100px">
        <el-form-item label="数据来源" prop="isNormal">
          <el-checkbox v-model="isNormalData" @change="handleNormalChange">{{ isNormalData ? '正常数据' : '自动生成' }}</el-checkbox>
        </el-form-item>
        <el-form-item label="关联人员" prop="relationId" required>
          <el-select
              v-model="relationForm.relationId"
              placeholder="请选择关联人员"
              filterable
              clearable
              :loading="relationLoading"
              style="width: 100%;"
              @focus="handleRelationSelectFocus"
              @change="handleRelationSelectChange"
              :popper-append-to-body="false"
              popper-class="relation-select-popper"
              @visible-change="handleSelectVisible"
              value-key="id"
          >
            <div v-if="showRelationHeader" class="relation-header-container" slot="prefix">
              <div class="relation-header-row">
                <div class="relation-header-cell" style="flex:1;min-width:80px;">姓名</div>
                <div class="relation-header-cell" style="flex:1;min-width:60px;">性别</div>
                <div class="relation-header-cell" style="flex:1;min-width:60px;">年龄</div>
                <div class="relation-header-cell" style="flex:1;min-width:80px;">民族</div>
                <div class="relation-header-cell" style="flex:1;min-width:80px;">国籍</div>
                <div class="relation-header-cell" style="flex:1;min-width:120px;">证件号码</div>
                <div class="relation-header-cell" style="flex:1;min-width:100px;">职业</div>
              </div>
            </div>
            <el-option
                v-for="item in filteredRelationOptions"
                :key="item.id"
                :label="`${item.name || '无名氏'} (${item.certNo || item.certno || '无证件'})`"
                :value="item.id"
                :disabled="item.id === currentAssociationPatientId"
            >
              <el-tooltip v-if="item.id === currentAssociationPatientId" effect="dark" content="同一人员不能相互关联！" placement="top">
                <div class="relation-option-content">
                  <div class="relation-data-cell" style="flex:1;min-width:80px;">{{ item.name || '--' }}</div>
                  <div class="relation-data-cell" style="flex:1;min-width:60px;">{{ getSexText(item.sex) }}</div>
                  <div class="relation-data-cell" style="flex:1;min-width:60px;">{{ item.age || '--' }}</div>
                  <div class="relation-data-cell" style="flex:1;min-width:80px;">{{ getNatyText(item.naty) }}</div>
                  <div class="relation-data-cell" style="flex:1;min-width:80px;">{{ getNtlyText(item.ntlyId) }}</div>
                  <div class="relation-data-cell" style="flex:1;min-width:120px;">{{ item.certNo || item.certno || '--' }}</div>
                  <div class="relation-data-cell" style="flex:1;min-width:100px;">{{ getJobText(item.jobId) }}</div>
                </div>
              </el-tooltip>
              <div v-else class="relation-option-content">
                <div class="relation-data-cell" style="flex:1;min-width:80px;">{{ item.name || '--' }}</div>
                <div class="relation-data-cell" style="flex:1;min-width:60px;">{{ getSexText(item.sex) }}</div>
                <div class="relation-data-cell" style="flex:1;min-width:60px;">{{ item.age || '--' }}</div>
                <div class="relation-data-cell" style="flex:1;min-width:80px;">{{ getNatyText(item.naty) }}</div>
                <div class="relation-data-cell" style="flex:1;min-width:80px;">{{ getNtlyText(item.ntlyId) }}</div>
                <div class="relation-data-cell" style="flex:1;min-width:120px;">{{ item.certNo || item.certno || '--' }}</div>
                <div class="relation-data-cell" style="flex:1;min-width:100px;">{{ getJobText(item.jobId) }}</div>
              </div>
            </el-option>
            <el-option v-if="!relationLoading && relationOptions.length === 0" disabled style="text-align:center;color:#909399;">暂无数据</el-option>
            <el-option v-if="relationLoading" disabled style="text-align:center;color:#909399;"><i class="el-icon-loading"></i> 加载中...</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="relationForm.remark" type="textarea" :rows="3" placeholder="请输入备注信息"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addRelationDialogVisible = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmAddRelation">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 患者360详情弹窗 -->
    <el-dialog
      title="患者360"
      :visible.sync="patient360DialogVisible"
      width="64%"
      top="3vh"
      :close-on-click-modal="false"
      class="patient360-dialog"
      @opened="initConsumeStructureChart"
      @closed="disposeConsumeStructureChart"
    >
      <div v-loading="patient360Loading" class="patient360-container">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="6">
            <div class="info-card equal-height-card">
              <div class="card-title">基础信息</div>
              <div class="card-content">
                <div class="info-item"><span class="label">姓名：</span>{{ patient360Data.basic.name }}</div>
                <div class="info-item"><span class="label">性别 / 年龄：</span>{{ patient360Data.basic.sex + patient360Data.basic.age + '岁' }}</div>
                <div class="info-item"><span class="label">电话：</span>{{ patient360Data.basic.tel }}</div>
                <div class="info-item">
                  <span class="label">脱敏地址：</span>
                  <el-tooltip
                    v-if="patient360Data.basic.fullAddress && patient360Data.basic.fullAddress.length > 20"
                    :content="patient360Data.basic.fullAddress"
                    placement="top"
                    effect="dark"
                    popper-class="address-tooltip"
                  >
                    <span class="address-text">
                      {{ patient360Data.basic.showFullAddress ? patient360Data.basic.fullAddress : (patient360Data.basic.fullAddress ? patient360Data.basic.fullAddress.substring(0, 6) + '****' : '--') }}
                    </span>
                  </el-tooltip>
                  <span v-else class="address-text">
                    {{ patient360Data.basic.showFullAddress ? patient360Data.basic.fullAddress : (patient360Data.basic.fullAddress ? patient360Data.basic.fullAddress.substring(0, 6) + '****' : '--') }}
                  </span>
                </div>
                <div class="info-item"><span class="label">证件号码：</span>{{ patient360Data.basic.certno }}</div>
                <div class="info-item"><span class="label">出生日期：</span>{{ patient360Data.basic.brdy }}</div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="info-card equal-height-card">
              <div class="card-title">就诊概览</div>
              <div class="card-content">
                <div class="info-item"><span class="label">累计就诊次数</span><span class="value">{{ patient360Data.visitOverview.completedVisitCount }}</span></div>
                <div class="info-item"><span class="label">最近就诊日期</span><span class="value">{{ patient360Data.visitOverview.latestVisitTime }}</span></div>
                <div class="info-item"><span class="label">累计净消费</span><span class="value">¥{{ patient360Data.visitOverview.cumulativeNetAmount }}</span></div>
                <div class="info-item"><span class="label">平均客单价</span><span class="value">¥{{ patient360Data.visitOverview.averageCustomerSpend }}</span></div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="info-card equal-height-card">
              <div class="card-title">长期诊疗特征</div>
              <div class="card-content">
                <div class="info-item"><span class="label">累计消费</span><span class="value">¥{{ patient360Data.longTermTreatment.totalCost }}</span></div>
                <div class="info-item"><span class="label">平均订单价</span><span class="value">¥{{ patient360Data.longTermTreatment.avgOrderPrice }}</span></div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="info-card equal-height-card">
              <div class="card-title">随药特征</div>
              <div class="card-content">
                <div class="info-item"><span class="label">剂量</span><span class="value">{{ patient360Data.medicationFeatures.dose }}</span></div>
                <div class="info-item"><span class="label">容量</span><span class="value">{{ patient360Data.medicationFeatures.capacity }}</span></div>
                <div class="info-item"><span class="label">高级医生</span><span class="value">{{ patient360Data.medicationFeatures.doctor }}</span></div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16" style="margin-top: 16px;">
          <el-col :xs="24" :sm="12" :md="6">
            <div class="info-card equal-height-card">
              <div class="card-title">高频理疗项目</div>
              <div class="card-content">
                <div v-for="item in patient360Data.frequentPhysiotherapyItems" :key="item.itemId" class="info-item">
                  <span class="label">{{ item.itemName }}</span>
                  <span class="value">{{ item.occurrenceCount }}次</span>
                </div>
                <div v-if="patient360Data.frequentPhysiotherapyItems.length === 0" class="info-item">
                  <span class="label">暂无数据</span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="info-card equal-height-card">
              <div class="card-title">用药特征</div>
              <div class="card-content">
                <div v-for="item in patient360Data.medicationFeaturesList" :key="item.itemId" class="info-item">
                  <span class="label">{{ item.itemName }}</span>
                  <span class="value">{{ item.totalQuantity }}{{ item.unitName }}</span>
                </div>
                <div v-if="patient360Data.medicationFeaturesList.length === 0" class="info-item">
                  <span class="label">暂无数据</span>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="info-card equal-height-card">
              <div class="card-title">消费结构</div>
              <div class="card-content chart-content">
                <div id="consumeStructureChart" style="height: 100px; width: 100%;"></div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="6">
            <div class="info-card equal-height-card">
              <div class="card-title">过敏信息</div>
              <div class="card-content">
                <div v-for="item in patient360Data.rhrAlgs" :key="item.aiseId" class="info-item">
                  <span class="label">{{ item.algsDese }}</span>
                  <span class="value">{{ item.type === 1 ? '药品' : '其它' }}</span>
                </div>
                <div v-if="patient360Data.rhrAlgs.length === 0" class="info-item">
                  <span class="label">暂无过敏记录</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16" style="margin-top: 16px;">
          <el-col :span="24">
            <div class="info-card equal-height-card timeline-card">
              <div class="card-title">就诊时间线</div>
              <div class="card-content timeline-horizontal">
                <div v-if="patient360Data.visitTimeline.length > 0" class="timeline-scroll">
                  <div class="timeline-node" v-for="(item, index) in patient360Data.visitTimeline" :key="index">
                    <div class="timeline-time">{{ item.visitTime }}</div>
                    <div class="timeline-dot"></div>
                    <div class="timeline-content-text">{{ item.doctorName }}（{{ item.statusName }}）</div>
                  </div>
                </div>
                <div v-else style="text-align: center; color: #909399; padding: 20px 0;">
                  暂无就诊记录
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { docphrpage } from "@/api/Outpatient/Healthrecords";
import { getFinishReception } from "@/api/reservation/outpatientPhysician";
import { feeListStatics } from "@/api/reservation/outpatientChargeList";
import { dict } from "@/api/staff/staff.js"
import { addRelationPhr, deleteRelation, listRelation, docphrList, v2Patient, aiseDetails } from "@/api/reservation/healthrecords.js"

// ===== 患者类型映射 =====
const PHR_TYPE_MAP = {
  1: { label: '普通患者', tagType: 'info' },
  2: { label: '核心患者', tagType: 'primary' },
  3: { label: '重点患者', tagType: 'warning' },
  4: { label: '流失核心患者', tagType: 'danger' }
}

export default {
  name: 'HealthrecordsStaistics',
  data() {
    return {
      activeTab: 'dashboard',
      chartReady: false,

      dashboardLoading: false,
      isMonthlyNewMode: false,

      timePreset: '7d',
      dateRange: this.getDefaultDateRange('7d'),

      trendViewType: 'month',
      trendCurrentLabel: '',
      trendDataRaw: [],

      statData: {
        totalPatients: 0,
        totalGrowth: 0,
        monthlyNew: 0,
        monthlyGrowth: 0,
        followedPatients: 0,
        monthlyVisits: 0,
        revisitRate: 0,
        averageCustomerSpend: 0,
      },

      drugTop10: [],
      treatmentTop10: [],

      conversionData: [],
      doctorData: [],
      ageData: [],
      revenueData: [],

      chartInstances: {},
      resizeObservers: [],

      // ===== 患者列表相关 =====
      timeRange: '3m',
      patientType: null, // 患者类型（数字：1/2/3/4；null/'' 表示全部，不传 phrType）
      searchName: '',
      patientList: [],
      totalPatient: 0,
      currentPage: 1,
      pageSize: 20,
      tableHeight: 400,

      // ===== 关联信息相关 =====
      associationDialogVisible: false,
      relationData: [],
      currentAssociationPatient: null,
      currentAssociationPatientId: null,
      addRelationDialogVisible: false,
      relationForm: { relationId: null, remark: '' },
      isNormalData: true,
      relationOptions: [],
      relationLoading: false,
      showRelationHeader: false,
      isReRelationMode: false,
      reRelationRow: null,
      sexTextMap: { 0: '未知', 1: '男', 2: '女', 9: '未说明' },
      natyOptions: [],
      ntlyOptions: [],
      jobOptions: [],

      // ===== 患者360详情弹窗 =====
      patient360DialogVisible: false,
      patient360Loading: false,
      patient360Data: {
        basic: {
          name: '',
          sex: '',
          age: '',
          tel: '',
          fullAddress: '',
          showFullAddress: false,
          certno: '',
          brdy: ''
        },
        visitOverview: { completedVisitCount: 0, latestVisitTime: '', cumulativeNetAmount: 0, averageCustomerSpend: 0 },
        longTermTreatment: { totalCost: 0, avgOrderPrice: 0 },
        medicationFeatures: { dose: '--', capacity: '--', doctor: '--' },
        frequentPhysiotherapyItems: [],
        medicationFeaturesList: [],
        rhrAlgs: [],
        visitTimeline: []
      },
      consumeStructureChart: null,
      consumeStructureData: [],
      detailQueryParams: { patientId: '' },
      detailLoading: false,
      statisticsLoading: false,
      firstVisitTime: '',
      totalVisits: 0,
      totalExpenditure: 0,
      allVisitData: [],
      detailTableData: [],
      detailTotalSize: 0,
      detailPageNum: 1,
      detailPageSize: 10,
      detailTableRows: [],
      doctorOptions: [],
      sexOptions: [
        {id: 1, label: '男'},
        {id: 2, label: '女'}
      ]
    }
  },
  computed: {
    filterSummary() {
      const parts = []
      if (this.patientType !== '' && this.patientType !== null && this.patientType !== undefined) {
        parts.push(`患者类型:${this.getPhrTypeLabel(this.patientType)}`)
      }
      if (this.searchName) parts.push(`搜索:"${this.searchName}"`)
      let summary = parts.length ? parts.join('；') : '全部患者'
      if (this.isMonthlyNewMode) {
        summary += '（月新增模式）'
      }
      return summary
    },
    filteredRelationOptions() {
      return this.relationOptions
    },
    relationDialogTitle() {
      if (this.isReRelationMode && this.reRelationRow && this.reRelationRow.name) {
        return `为【${this.reRelationRow.name}】重新关联人员`
      }
      return '添加关联'
    },
    avgPricePercentage() {
      const avg = this.statData.averageCustomerSpend || 0
      if (avg === 0) return 0
      let maxVal = Math.ceil(avg * 1.5 / 100) * 100
      if (maxVal === 0) maxVal = 100
      let pct = (avg / maxVal) * 100
      return Math.min(pct, 100)
    }
  },
  mounted() {
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
    this.loadPatientList()
    this.getDictData()
    window.addEventListener('resize', this.handleResize)
    this.$nextTick(() => {
      this.calculateTableHeight()
      this.loadDashboardData()
      this.updateTrendLabel()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    this.resizeObservers.forEach(observer => observer.disconnect())
    this.resizeObservers = []
    Object.values(this.chartInstances).forEach(chart => chart.dispose())
    this.disposeConsumeStructureChart()
  },
  methods: {
    // ==================== 患者类型映射 ====================
    getPhrTypeLabel(phrType) {
      const num = Number(phrType)
      const item = PHR_TYPE_MAP[num]
      return item ? item.label : '-'
    },
    getPhrTypeTagType(phrType) {
      const num = Number(phrType)
      const item = PHR_TYPE_MAP[num]
      return item ? item.tagType : 'info'
    },

    // ==================== 顶部筛选器 ====================
    getDefaultDateRange(preset) {
      const now = new Date()
      let start = new Date(now)
      switch (preset) {
        case '7d': start.setDate(start.getDate() - 7); break
        case '30d': start.setDate(start.getDate() - 30); break
        case '90d': start.setDate(start.getDate() - 90); break
        case '0d': start = new Date(now); break
        default: start.setDate(start.getDate() - 7)
      }
      const formatDate = (d) => {
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      }
      return [formatDate(start), formatDate(now)]
    },
    handleTimePresetChange(val) {
      this.dateRange = this.getDefaultDateRange(val)
      this.chartReady = false
      this.loadDashboardData()
    },
    handleDateRangeChange(val) {
      if (val && val.length === 2) {
        this.timePreset = ''
        this.chartReady = false
        this.loadDashboardData()
      }
    },

    // ==================== 卡片点击跳转 ====================
    handleTotalPatientsClick() {
      this.isMonthlyNewMode = false
      this.activeTab = 'patientList'
      if (this.patientList.length === 0) {
        this.loadPatientList()
      }
    },
    handleMonthlyNewClick() {
      this.isMonthlyNewMode = true
      this.activeTab = 'patientList'
      if (this.patientList.length === 0) {
        this.loadPatientList()
      }
    },

    // ==================== 数据看板核心加载 ====================
    async loadDashboardData() {
      this.dashboardLoading = true
      try {
        const [start, end] = this.dateRange
        const startDate = new Date(start)
        const endDate = new Date(end)
        const startTime = this.formatDateToTime(startDate, '00:00:00')
        const endTime = this.formatDateToTime(endDate, '23:59:59')

        const params = {
          startTime: startTime,
          endTime: endTime
        }
        const res = await v2Patient(params)
        if (res && res.code === 200 && res.data) {
          this.processDashboardData(res.data)
          this.$nextTick(() => {
            this.chartReady = true
            this.$nextTick(() => {
              this.initCharts()
            })
          })
        } else {
          this.$message.error(res?.message || '获取看板数据失败')
          this.clearDashboardData()
        }
      } catch (error) {
        console.error('加载看板数据失败', error)
        this.$message.error('加载看板数据失败')
        this.clearDashboardData()
      } finally {
        this.dashboardLoading = false
      }
    },

    formatDateToTime(date, timeStr) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day} ${timeStr}`
    },

    clearDashboardData() {
      this.statData = {
        totalPatients: 0,
        totalGrowth: 0,
        monthlyNew: 0,
        monthlyGrowth: 0,
        followedPatients: 0,
        monthlyVisits: 0,
        revisitRate: 0,
        averageCustomerSpend: 0,
      }
      this.drugTop10 = []
      this.treatmentTop10 = []
      this.conversionData = []
      this.doctorData = []
      this.ageData = []
      this.revenueData = []
    },

    processDashboardData(data) {
      this.statData = {
        totalPatients: data.totalPatientCount || 0,
        totalGrowth: data.totalGrowthRate || 0,
        monthlyNew: data.monthlyNewPatientCount || 0,
        monthlyGrowth: data.monthlyGrowthRate || 0,
        followedPatients: data.corePatientCount || 0,
        monthlyVisits: data.monthlyVisitCount || data.totalPatientCount || 0,
        revisitRate: data.revisitRate || 0,
        averageCustomerSpend: data.averageCustomerSpend || 0,
      }

      this.drugTop10 = (data.topDrugs || []).slice(0, 10).map(item => ({
        name: item.itemName || '未知药品',
        percent: item.totalQuantity || 0
      }))

      this.treatmentTop10 = (data.topCareItems || []).slice(0, 10).map(item => ({
        name: item.itemName || '未知项目',
        percent: item.totalQuantity || 0
      }))

      this.conversionData = (data.topConsumers || []).slice(0, 4).map(item => ({
        name: item.patientName || '患者',
        value: item.consumptionAmount || 0
      }))

      this.doctorData = (data.topDoctors || []).slice(0, 5).map(item => ({
        name: item.doctorName || '医生',
        value: item.visitCount || 0
      }))

      this.ageData = (data.ageDistribution || []).map(item => ({
        range: item.categoryName || '未知',
        value: item.patientCount || 0
      }))

      this.revenueData = (data.revenueComposition || []).map(item => ({
        name: item.categoryName || '类型',
        value: item.amount || 0,
        rate: item.rate || 0,
        code: item.categoryCode || ''
      }))
    },

    // ==================== 就诊趋势（不再使用） ====================
    updateTrendLabel() {},
    async updateTrendData() {},
    handleTrendViewChange(val) {},

    // ==================== 图表初始化 ====================
    initCharts() {
      if (this.activeTab !== 'dashboard' || !this.chartReady) return
      const chartIds = ['conversionChart', 'revisitRateChart', 'doctorChart', 'ageChart', 'revenueChart', 'avgPriceChart']
      chartIds.forEach(id => {
        const dom = document.getElementById(id)
        if (!dom) return
        const oldObs = this.resizeObservers.find(o => o.target === dom)
        if (oldObs) { oldObs.disconnect(); this.resizeObservers = this.resizeObservers.filter(o => o.target !== dom) }
        const observer = new ResizeObserver(() => {
          if (dom.clientWidth > 0) this.initChart(id)
        })
        observer.observe(dom)
        this.resizeObservers.push(observer)
        setTimeout(() => this.initChart(id), 50)
      })
    },

    initChart(domId) {
      const dom = document.getElementById(domId)
      if (!dom) return

      const parent = dom.parentElement
      if (parent) {
        const parentRect = parent.getBoundingClientRect()
        let height = parentRect.height
        if (height === 0) {
          const cardTop = dom.closest('.card-top')
          const cardBottom = dom.closest('.card-bottom')
          const container = cardTop || cardBottom
          if (container) {
            const rect = container.getBoundingClientRect()
            height = rect.height
            if (height > 0) {
              const title = container.querySelector('.chart-card-title')
              let titleHeight = 0
              if (title) {
                const titleRect = title.getBoundingClientRect()
                titleHeight = titleRect.height + 8
              }
              height = height - titleHeight - 10
            }
          }
        }
        if (height > 0) {
          dom.style.height = height + 'px'
        } else {
          dom.style.height = '120px'
        }
      }

      if (this.chartInstances[domId]) {
        this.chartInstances[domId].dispose()
        delete this.chartInstances[domId]
      }

      const chart = echarts.init(dom)
      this.chartInstances[domId] = chart
      const option = this.getOptionById(domId).call(this)
      chart.setOption(option)
      chart.resize()
    },

    getOptionById(id) {
      const map = {
        'conversionChart': this.getConversionOption,
        'revisitRateChart': this.getRevisitRateLineOption,
        'doctorChart': this.getDoctorOption,
        'ageChart': this.getAgeLineOption,
        'revenueChart': this.getRevenueOption,
        'avgPriceChart': this.getAvgPriceLineOption,
      }
      return map[id] || (() => ({}))
    },

    getConversionOption() {
      let data = this.conversionData || []
      if (data.length === 0) {
        data = [{ name: '暂无数据', value: 1 }]
      }
      const colors = ['#1677FF', '#FA8C16', '#D9D9D9', '#52C41A']
      return {
        tooltip: { trigger: 'item' },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: { fontSize: 11 },
          data: data.map(d => d.name)
        },
        series: [{
          type: 'pie',
          radius: ['55%', '75%'],
          center: ['45%', '50%'],
          avoidLabelOverlap: false,
          itemStyle: { borderRadius: 4, borderColor: '#fff', borderWidth: 2 },
          label: { show: false },
          labelLine: { show: false },
          emphasis: { scale: false },
          data: data.map((d, i) => ({ value: d.value, name: d.name, itemStyle: { color: colors[i % colors.length] } }))
        }]
      }
    },

    getRevisitRateLineOption() {
      const rate = this.statData.revisitRate || 0
      const data = [
        { name: '当前', value: rate }
      ]
      return {
        tooltip: {
          trigger: 'item',
          formatter: () => `复诊率：${rate}%`
        },
        grid: {
          left: '10%',
          right: '8%',
          top: '15%',
          bottom: '15%'
        },
        xAxis: {
          type: 'category',
          data: [''],
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 100,
          splitLine: { lineStyle: { color: '#e8e8e8', type: 'dashed' } },
          axisLabel: {
            formatter: '{value}%',
            fontSize: 10
          },
          name: '',
          nameTextStyle: { fontSize: 10 }
        },
        series: [{
          type: 'scatter',
          symbolSize: 16,
          data: data.map(d => ({ value: d.value, name: d.name })),
          label: {
            show: true,
            formatter: (p) => p.value + '%',
            position: 'top',
            fontSize: 12,
            color: '#1677FF',
            fontWeight: 'bold'
          },
          itemStyle: {
            color: '#1677FF',
            shadowBlur: 6,
            shadowColor: 'rgba(22,119,255,0.4)'
          },
          markLine: {
            silent: true,
            data: [
              {
                yAxis: rate,
                lineStyle: { color: '#1677FF', width: 2, type: 'dashed' }
              }
            ],
            label: { show: false }
          }
        }]
      }
    },

    getDoctorOption() {
      let data = this.doctorData || []
      if (data.length === 0) {
        data = [{ name: '暂无数据', value: 0 }]
      }
      const names = data.map(d => d.name)
      const values = data.map(d => d.value)
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: '5%', right: '5%', top: '10%', bottom: '5%' },
        xAxis: { type: 'category', data: names, axisLabel: { fontSize: 9, interval: 0 }, axisLine: { show: false }, axisTick: { show: false } },
        yAxis: { type: 'value', show: false, min: 0 },
        series: [{ type: 'bar', barWidth: '40%', data: values.map(v => ({ value: v, itemStyle: { color: '#1677FF' } })), label: { show: true, position: 'top', fontSize: 9, color: '#333' } }]
      }
    },

    getAgeLineOption() {
      let data = this.ageData || []
      if (data.length === 0) {
        data = [{ range: '暂无数据', value: 0 }]
      }
      const names = data.map(d => d.range)
      const values = data.map(d => d.value)
      return {
        tooltip: { trigger: 'axis' },
        grid: { left: '8%', right: '5%', top: '10%', bottom: '8%' },
        xAxis: { type: 'category', data: names, axisLabel: { fontSize: 10 }, axisLine: { show: true }, axisTick: { show: true } },
        yAxis: { type: 'value', min: 0, splitLine: { lineStyle: { color: '#f0f0f0', type: 'dashed' } }, axisLabel: { fontSize: 10 } },
        series: [{
          type: 'line',
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          lineStyle: { color: '#1677FF', width: 2 },
          areaStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [ { offset: 0, color: 'rgba(22, 119, 255, 0.3)' }, { offset: 1, color: 'rgba(22, 119, 255, 0.02)' } ] } },
          data: values.map(v => ({ value: v, itemStyle: { color: '#1677FF' } })),
          label: { show: true, position: 'top', fontSize: 9, color: '#333' }
        }]
      }
    },

    getAvgPriceLineOption() {
      const avg = this.statData.averageCustomerSpend || 0
      let maxVal = Math.ceil(avg * 1.5 / 100) * 100
      if (maxVal === 0) maxVal = 100
      const data = [
        { name: '当前', value: avg }
      ]
      return {
        tooltip: {
          trigger: 'item',
          formatter: () => `平均客单价：¥${avg}`
        },
        grid: {
          left: '12%',
          right: '8%',
          top: '15%',
          bottom: '15%'
        },
        xAxis: {
          type: 'category',
          data: [''],
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false }
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: maxVal,
          splitLine: { lineStyle: { color: '#e8e8e8', type: 'dashed' } },
          axisLabel: {
            formatter: '¥{value}',
            fontSize: 10
          },
          name: '',
          nameTextStyle: { fontSize: 10 }
        },
        series: [{
          type: 'scatter',
          symbolSize: 16,
          data: data.map(d => ({ value: d.value, name: d.name })),
          label: {
            show: true,
            formatter: (p) => '¥' + p.value,
            position: 'top',
            fontSize: 12,
            color: '#1677FF',
            fontWeight: 'bold'
          },
          itemStyle: {
            color: '#1677FF',
            shadowBlur: 6,
            shadowColor: 'rgba(22,119,255,0.4)'
          },
          markLine: {
            silent: true,
            data: [
              {
                yAxis: avg,
                lineStyle: { color: '#1677FF', width: 2, type: 'dashed' }
              }
            ],
            label: { show: false }
          }
        }]
      }
    },

    getRevenueOption() {
      let data = this.revenueData || []
      if (data.length === 0) {
        data = [{ name: '暂无数据', value: 1 }]
      }
      const colors = ['#1677FF', '#52C41A', '#D9D9D9', '#FA8C16', '#F5222D']
      return {
        tooltip: { trigger: 'item' },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 'center',
          textStyle: { fontSize: 11 },
          data: data.map(d => d.name)
        },
        series: [{
          type: 'pie',
          radius: ['50%', '70%'],
          center: ['45%', '50%'],
          avoidLabelOverlap: false,
          itemStyle: { borderRadius: 4, borderColor: '#fff', borderWidth: 2 },
          label: { show: true, formatter: '{b}\n{d}%' },
          labelLine: { show: true },
          emphasis: { scale: false },
          data: data.map((d, i) => ({
            value: d.value || 0,
            name: d.name,
            itemStyle: { color: colors[i % colors.length] }
          }))
        }]
      }
    },

    resizeCharts() {
      Object.values(this.chartInstances).forEach(chart => chart.resize())
    },

    // ==================== 患者列表 ====================
    async loadPatientList() {
      try {
        const params = {
          name: this.searchName || '',
          pageNum: this.currentPage,
          pageSize: this.pageSize
        }
        // 只有选择了具体患者类型时才传 phrType（选择"全部"或清空后不传）
        if (this.patientType !== null && this.patientType !== undefined && this.patientType !== '') {
          params.phrType = this.patientType
        }
    
        const res = await docphrpage(params)
    
        const data = res.data || {}
        let list = data.content
        if (!list || !Array.isArray(list) || list.length === 0) {
          list = data.records || data.list || data.rows || []
        }
        if (!Array.isArray(list)) {
          list = []
        }
        this.patientList = list
        this.totalPatient = data.totalSize || data.total || data.totalElements || list.length || 0
        this.$nextTick(() => this.calculateTableHeight())
      } catch (error) {
        console.error('加载患者列表失败', error)
        this.$message.error('加载患者列表失败')
      }
    },
    handleSearch() { this.currentPage = 1; this.loadPatientList() },
    handlePageChange(page) { this.currentPage = page; this.loadPatientList() },
    handleSizeChange(size) { this.pageSize = size; this.currentPage = 1; this.loadPatientList() },
    handleRowClick(row) { this.setCurrent(row) },
    setCurrent(row) {
      this.$nextTick(() => {
        if (this.$refs.patientTable) this.$refs.patientTable.setCurrentRow(row)
      })
    },
    calculateTableHeight() {
      const wrapper = this.$refs.patientTable ? this.$refs.patientTable.$el.closest('.table-wrapper') : null
      if (wrapper) {
        this.tableHeight = Math.max(200, wrapper.clientHeight - 80)
      } else {
        this.tableHeight = Math.max(200, window.innerHeight - 350)
      }
    },
    handleResize() {
      this.calculateTableHeight()
      this.resizeCharts()
    },

    handleTabClick(tab) {
      if (tab.name === 'dashboard') {
        if (!this.chartReady) this.loadDashboardData()
        else this.$nextTick(() => this.initCharts())
      } else if (tab.name === 'patientList') {
        if (this.patientList.length === 0) this.loadPatientList()
        this.$nextTick(() => this.calculateTableHeight())
      }
    },

    // ==================== 行高亮 ====================
    getRowClassName({ row }) {
      if (this.isMonthlyNewMode && row.createTime) {
        const now = new Date()
        const create = new Date(row.createTime)
        if (now.getFullYear() === create.getFullYear() && now.getMonth() === create.getMonth()) {
          return 'row-highlight-monthly-new'
        }
      }
      return ''
    },

    // ==================== 日期格式化 ====================
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const date = new Date(dateStr)
      if (isNaN(date.getTime())) return '-'
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // ==================== 字典数据 ====================
    async getDictData() {
      try {
        const res = await dict()
        if (res.code === 200 && res.data) {
          this.natyOptions = (res.data.natyEntities || []).map(v => ({ label: v.name, ...v }))
          this.ntlyOptions = (res.data.country || []).map(v => ({ label: v.name, ...v }))
          this.jobOptions = (res.data.jobEntities || []).map(v => ({ label: v.name, ...v }))
        }
      } catch (error) {
        console.error('获取字典数据失败', error)
      }
    },
    getSexText(sex) { return this.sexTextMap[sex] || '未知' },
    getNatyText(natyId) {
      if (!natyId) return '--'
      const item = this.natyOptions.find(v => v.id === natyId)
      return item ? item.label : '--'
    },
    getNtlyText(ntlyId) {
      if (!ntlyId) return '--'
      const item = this.ntlyOptions.find(v => v.id === ntlyId)
      return item ? item.label : '--'
    },
    getJobText(jobId) {
      if (!jobId) return '--'
      const item = this.jobOptions.find(v => v.id === jobId)
      return item ? item.label : '--'
    },

    // ==================== 关联功能 ====================
    handleAssociation(row) {
      this.currentAssociationPatient = row
      this.currentAssociationPatientId = row.id
      this.associationDialogVisible = true
      this.loadRelationData(row.id)
    },
    async loadRelationData(id) {
      if (!id) return
      try {
        const res = await listRelation({ id: id })
        if (res.code === 200 && res.data) {
          this.relationData = res.data.map(item => ({
            ...item,
            id: item.id || item.relationId,
            relationId: item.relationId || item.id,
            name: item.name || '',
            sex: item.sex || 0,
            tel: item.tel || '',
            certNo: item.certNo || item.certno || '',
            remark: item.remark || ''
          }))
        } else {
          this.relationData = []
        }
      } catch (error) {
        console.error('加载关联数据失败', error)
        this.relationData = []
      }
    },
    openAddRelationDialog() {
      if (!this.currentAssociationPatientId) { this.$message.warning('请先选择患者'); return }
      this.relationForm = { relationId: null, remark: '' }
      this.isNormalData = true
      this.relationOptions = []
      this.isReRelationMode = false
      this.reRelationRow = null
      this.addRelationDialogVisible = true
      this.$nextTick(() => this.loadRelationOptions())
    },
    handleReRelation(row) {
      if (!this.currentAssociationPatientId) return
      this.isReRelationMode = true
      this.reRelationRow = row
      this.relationForm = { relationId: null, remark: row.remark || '' }
      this.isNormalData = true
      this.relationOptions = []
      this.addRelationDialogVisible = true
      this.$nextTick(() => this.loadRelationOptions())
    },
    async loadRelationOptions() {
      if (!this.currentAssociationPatientId) { this.$message.warning('请先选择患者'); return }
      this.relationLoading = true
      try {
        const params = { condition: this.currentAssociationPatientId, type: this.isNormalData ? 1 : 2, pageNum: 1, pageSize: 1000 }
        const res = await docphrList(params)
        if (res.code === 200 && res.data) {
          this.relationOptions = res.data.map(item => ({ ...item, id: item.id || 0, name: item.name || '', sex: item.sex || 0, age: item.age || 0, naty: item.naty || 0, ntlyId: item.ntlyId || '', certNo: item.certNo || item.certno || '', jobId: item.jobId || 0 }))
        } else { this.relationOptions = [] }
      } catch (error) {
        console.error('加载关联人员列表失败', error)
        this.relationOptions = []
      } finally { this.relationLoading = false }
    },
    handleRelationSelectFocus() {
      if (this.relationOptions.length === 0 && !this.relationLoading) this.loadRelationOptions()
    },
    handleNormalChange(value) {
      this.isNormalData = value
      this.relationOptions = []
      this.loadRelationOptions()
    },
    handleRelationSelectChange(value) {},
    handleSelectVisible(visible) {
      this.showRelationHeader = visible
      if (visible && this.relationOptions.length === 0 && !this.relationLoading) this.loadRelationOptions()
    },
    async confirmAddRelation() {
      if (!this.relationForm.relationId) { this.$message.warning('请选择关联人员'); return }
      if (this.relationForm.relationId === this.currentAssociationPatientId) { this.$message.warning('同一人员不能相互关联'); return }
      try {
        const params = { phrMainId: this.currentAssociationPatientId, phrRelationId: this.relationForm.relationId, remark: this.relationForm.remark || '' }
        let res
        if (this.isReRelationMode && this.reRelationRow) {
          const deleteRes = await deleteRelation({ relationId: this.reRelationRow.id || this.reRelationRow.relationId })
          if (deleteRes.code === 200) res = await addRelationPhr(params)
          else { this.$message.error(deleteRes.message || '删除原有关联失败'); return }
        } else {
          res = await addRelationPhr(params)
        }
        if (res.code === 200) {
          this.$message.success(this.isReRelationMode ? '重新关联成功' : '添加关联成功')
          this.addRelationDialogVisible = false
          this.relationForm = { relationId: null, remark: '' }
          this.isReRelationMode = false
          this.reRelationRow = null
          await this.loadRelationData(this.currentAssociationPatientId)
        } else {
          this.$message.error(res.message || '操作失败')
        }
      } catch (error) {
        console.error('关联操作失败', error)
        this.$message.error('操作失败')
      }
    },
    async handleCancelRelation(row) {
      try {
        await this.$confirm('确定要取消这条关联记录吗？', '提示', { type: 'warning' })
        const relationId = row.id || row.relationId
        if (!relationId) { this.$message.warning('无法获取关联记录ID'); return }
        const res = await deleteRelation({ relationId: relationId })
        if (res.code === 200) {
          this.$message.success('取消关联成功')
          await this.loadRelationData(this.currentAssociationPatientId)
        } else {
          this.$message.error(res.message || '取消关联失败')
        }
      } catch (error) {
        if (error !== 'cancel') console.error('取消关联失败', error)
      }
    },
    handleAssociationClose() {
      this.associationDialogVisible = false
      this.currentAssociationPatient = null
      this.currentAssociationPatientId = null
      this.relationData = []
    },
    handleRelationDialogClose(done) {
      this.$confirm('确认关闭？', '提示', { type: 'warning' }).then(() => {
        this.addRelationDialogVisible = false
        this.isReRelationMode = false
        this.reRelationRow = null
        if (done) done()
      }).catch(() => {})
    },

    // ==================== 患者360详情 ====================
    async handleViewDetail(row) {
      this.patient360DialogVisible = true
      this.patient360Loading = true
      try {
        const res = await aiseDetails({ id: row.id })
        if ((res.code === 0 || res.code === 200) && res.data) {
          const data = res.data
          const basic = {
            name: data.name || '--',
            sex: this.getSexText(data.sex),
            age: data.age || '--',
            tel: data.tel || '--',
            fullAddress: data.conerAddName || '--',
            showFullAddress: false,
            certno: data.certno || '--',
            brdy: data.brdy ? this.formatDate(data.brdy) : '--'
          }

          const visitOverview = {
            completedVisitCount: data.visitOverview?.completedVisitCount || 0,
            latestVisitTime: data.visitOverview?.latestVisitTime ? this.formatDate(data.visitOverview.latestVisitTime) : '暂无',
            cumulativeNetAmount: data.visitOverview?.cumulativeNetAmount || 0,
            averageCustomerSpend: data.visitOverview?.averageCustomerSpend || 0
          }

          const longTermTreatment = {
            totalCost: data.visitOverview?.cumulativeNetAmount || 0,
            avgOrderPrice: data.visitOverview?.averageCustomerSpend || 0
          }

          const medicationFeatures = {
            dose: '--',
            capacity: '--',
            doctor: '--'
          }

          const frequentPhysiotherapyItems = data.frequentPhysiotherapyItems || []
          const medicationFeaturesList = data.medicationFeatures || []
          const rhrAlgs = data.rhrAlgs || []

          const visitTimeline = (data.visitTimeline || []).map(item => ({
            visitTime: item.visitTime ? this.formatDate(item.visitTime) : '--',
            doctorName: item.doctorName || '--',
            statusName: item.statusName || '--'
          }))

          this.consumeStructureData = (data.consumptionStructure || []).map(item => ({
            name: item.categoryName || '其他',
            value: item.amount || 0
          }))

          this.patient360Data = {
            basic,
            visitOverview,
            longTermTreatment,
            medicationFeatures,
            frequentPhysiotherapyItems,
            medicationFeaturesList,
            rhrAlgs,
            visitTimeline
          }

          this.patient360Loading = false
          this.$nextTick(() => {
            this.initConsumeStructureChart()
          })
        } else {
          this.$message.error(res.message || '获取患者360数据失败')
          this.patient360Loading = false
        }
      } catch (error) {
        console.error('加载患者360数据失败', error)
        this.$message.error('加载患者360数据失败')
        this.patient360Loading = false
      }
    },

    toggleAddressVisibility() {
      this.patient360Data.basic.showFullAddress = !this.patient360Data.basic.showFullAddress
    },

    initConsumeStructureChart() {
      const dom = document.getElementById('consumeStructureChart')
      if (!dom) {
        setTimeout(() => this.initConsumeStructureChart(), 200)
        return
      }
      if (this.consumeStructureChart) {
        this.consumeStructureChart.dispose()
      }
      this.consumeStructureChart = echarts.init(dom)
      const data = this.consumeStructureData.length > 0 ? this.consumeStructureData : [
        { name: '药品', value: 40 },
        { name: '治疗', value: 30 },
        { name: '检查', value: 20 },
        { name: '其他', value: 10 }
      ]
      const option = {
        tooltip: { trigger: 'item' },
        legend: {
          orient: 'horizontal',
          left: 'center',
          top: 'bottom',
          textStyle: { fontSize: 10 },
          itemWidth: 10,
          itemHeight: 10
        },
        series: [{
          type: 'pie',
          radius: ['45%', '70%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          itemStyle: { borderRadius: 4, borderColor: '#fff', borderWidth: 2 },
          label: { show: true, formatter: '{d}%', fontSize: 10 },
          emphasis: { scale: false },
          data: data.map(d => ({ value: d.value, name: d.name }))
        }]
      }
      this.consumeStructureChart.setOption(option)
      this.consumeStructureChart.resize()
    },

    disposeConsumeStructureChart() {
      if (this.consumeStructureChart) {
        this.consumeStructureChart.dispose()
        this.consumeStructureChart = null
      }
    },

    loadPatientTotalExpenditure() {},
    loadPatientStatistics() {},
    loadDetailData() {},
    handleDetailSearch() {},
    resetDetailQuery() {},
    handleDetailSizeChange() {},
    handleDetailCurrentChange() {},
    getDetailColumnWidth() {},
    getTextWidth() {},
    safeGetMappedValue() {},

    handleEdit(row) { this.$message('编辑患者：' + row.id) },
    handleExport() { this.$message.success('导出Excel成功') },
    handleAddPatient() { this.$message.success('打开新增患者对话框') }
  }
}
</script>

<style lang="less" scoped>
/* ===== 整体容器 ===== */
.health-dashboard {
  height: 100% !important;
  background: #f5f7fa !important;
  padding: 12px !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

/* ===== 顶部筛选器 + Tabs 同行 ===== */
.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: #f5f7fa;
  padding-bottom: 12px;
}
.dashboard-tabs {
  flex: 1;
  max-width: 300px;
}
.dashboard-tabs /deep/ .el-tabs__header {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}
.dashboard-tabs /deep/ .el-tabs__item {
  padding: 0 20px !important;
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #4e5969 !important;
}
.dashboard-tabs /deep/ .el-tabs__item.is-active { color: #1677FF !important; }
.dashboard-tabs /deep/ .el-tabs__active-bar { background-color: #1677FF !important; }

.filter-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* ===== 内容区域 ===== */
.tab-content-wrapper {
  flex: 1;
  overflow: hidden;
}
.tab-content {
  height: 100%;
  overflow: hidden;
}

/* ===== 数据看板布局 ===== */
.dashboard-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 300px;
}
.section-top {
  flex: 12 1 0%;
  min-height: 0;
  margin-bottom: 24px;
}
.section-middle {
  flex: 50 1 0%;
  min-height: 0;
  margin-bottom: 12px;
}
.section-bottom {
  flex: 38 1 0%;
  min-height: 0;
  margin-bottom: 0;
}
.section-top .el-row,
.section-bottom .el-row {
  height: 100% !important;
}
.section-bottom .bottom-row .el-col {
  height: 100% !important;
}

/* ===== 中间区域 - Grid 布局（4列） ===== */
.middle-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  height: 100%;
  align-content: stretch;
}
.middle-grid > .chart-card {
  min-width: 0;
  height: 100%;
}

/* ===== 底部右侧三列（flex行，横向平均分布） ===== */
.bottom-right-grid {
  display: flex;
  flex-direction: row;
  gap: 12px;
  height: 100%;
}
.bottom-sub-card {
  flex: 1;
  min-height: 0;
  width: 0;
  display: flex;
  flex-direction: column;
  padding: 4px 8px !important;
}

/* ===== 统计卡片 ===== */
.stat-card {
  background: #fff !important;
  border-radius: 8px !important;
  padding: 8px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06) !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  transition: box-shadow 0.3s ease, transform 0.2s ease;
  cursor: default;
}
.stat-card-label { font-size: 13px !important; color: #86909c !important; font-weight: 400 !important; margin-bottom: 2px !important; }
.stat-card-value { font-size: 24px !important; font-weight: 600 !important; color: #1d2129 !important; line-height: 1.2 !important; }
.stat-card-trend { font-size: 12px !important; margin-top: 2px !important; }
.trend-up { color: #f53f3f !important; }
.trend-down { color: #00b42a !important; }

/* ===== 可点击卡片 ===== */
.clickable-card {
  cursor: pointer !important;
}
.clickable-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important;
  transform: translateY(-2px);
}

/* ===== 悬停阴影卡片 ===== */
.hover-card {
  transition: box-shadow 0.3s ease, transform 0.2s ease;
}
.hover-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.10) !important;
  transform: translateY(-2px);
}

/* ===== 图表卡片 ===== */
.chart-card {
  background: #fff !important;
  border-radius: 8px !important;
  padding: 0 8px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06) !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  transition: box-shadow 0.3s ease, transform 0.2s ease;
}
.chart-card-title {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #1d2129 !important;
  margin-bottom: 4px !important;
  flex-shrink: 0 !important;
}
.card-top, .card-bottom {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}
.card-top { flex: 0 0 70%; }
.card-bottom { flex: 0 0 30%; }
.chart-card .card-top[style*="flex: 0 0 50%"] { flex: 0 0 50% !important; }
.chart-card .card-bottom[style*="flex: 0 0 50%"] { flex: 0 0 50% !important; }

.chart-container {
  flex: 1 1 0% !important;
  min-height: 0 !important;
  width: 100% !important;
  overflow: hidden !important;
}
.sub-title {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #606266 !important;
  margin: 4px 0 2px 0 !important;
  flex-shrink: 0 !important;
}

/* ===== 进度条列表 ===== */
.progress-list {
  flex: 1 1 0% !important;
  min-height: 0;
  margin-top: 4px;
  overflow-y: auto !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
.progress-list::-webkit-scrollbar { display: none !important; }
.progress-item {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  font-size: 11px !important;
  color: #4e5969 !important;
  padding: 2px 0 !important;
  height: 24px !important;
  flex-wrap: nowrap !important;
}
.progress-label {
  width: 60px !important;
  text-align: right !important;
  flex-shrink: 0 !important;
  font-size: 11px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  cursor: default;
}
.progress-item /deep/ .el-progress {
  flex: 1 !important;
  min-width: 0 !important;
}
.progress-item /deep/ .el-progress-bar {
  padding-right: 0 !important;
}
.progress-item /deep/ .el-progress__text {
  display: none !important;
}
.progress-percent {
  flex-shrink: 0 !important;
  font-size: 11px !important;
  color: #4e5969 !important;
  white-space: nowrap !important;
  margin-left: 4px;
  font-weight: 500;
}

/* ===== 复诊率进度条样式 ===== */
#revisitRateChart {
  height: 100%;
}
.el-progress {
  width: 100%;
}

/* ===== 运营转化底部 ===== */
.footer-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.footer-label { font-size: 11px; color: #86909c; }
.footer-value { font-size: 18px; font-weight: 600; color: #1d2129; }
.footer-trend { font-size: 11px; margin-top: 2px; }

/* ===== 营收占比 ===== */
.revenue-wrapper {
  display: flex !important;
  flex: 1 !important;
  align-items: stretch !important;
  gap: 10px !important;
  min-height: 0 !important;
}
.revenue-wrapper .chart-container {
  flex: 1 1 0% !important;
  min-height: 0 !important;
  height: 100% !important;
  width: 100% !important;
}

/* ===== 患者列表样式 ===== */
.patient-list-content {
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  height: 100% !important;
}
.filter-row {
  background: #fff !important;
  border-radius: 8px !important;
  padding: 10px 18px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06) !important;
  flex-shrink: 0 !important;
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  gap: 18px !important;
}
.filter-group { display: flex !important; align-items: center !important; gap: 6px !important; white-space: nowrap !important; }
.filter-label { font-size: 12px !important; color: #4e5969 !important; font-weight: 500 !important; }
.filter-buttons { display: flex !important; gap: 4px !important; }
.filter-buttons .el-button { padding: 4px 12px !important; font-size: 12px !important; border-radius: 4px !important; }
.search-group { margin-left: auto !important; display: flex !important; gap: 6px !important; align-items: center !important; }
.search-group .el-input { width: 160px !important; }
.filter-area {
  background: #fff !important;
  border-radius: 8px !important;
  padding: 12px 18px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06) !important;
  flex-shrink: 0 !important;
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
}
.filter-left { display: flex !important; align-items: baseline !important; gap: 8px !important; font-size: 13px !important; }
.filter-title { font-weight: 600 !important; color: #1d2129 !important; }
.filter-summary { color: #86909c !important; font-size: 12px !important; }

.table-wrapper {
  background: #fff !important;
  border-radius: 8px !important;
  padding: 12px 14px 8px 14px !important;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06) !important;
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  overflow: hidden !important;
}
.table-wrapper /deep/ .el-table { font-size: 12px !important; width: 100% !important; }
.table-wrapper /deep/ .el-table th { background: #f7f8fa !important; font-weight: 500 !important; color: #4e5969 !important; padding: 8px 0 !important; }
.table-wrapper /deep/ .el-table td { padding: 6px 0 !important; color: #1d2129 !important; }
.table-wrapper /deep/ .el-table--border, .table-wrapper /deep/ .el-table--border td, .table-wrapper /deep/ .el-table--border th { border-color: #e5e6eb !important; }
.table-wrapper /deep/ .el-table__row--striped { background: #fafafa !important; }
.table-wrapper /deep/ .el-table__body-wrapper { overflow-x: auto !important; overflow-y: auto !important; flex: 1 !important; }
.table-wrapper /deep/ .el-table__fixed-right { height: auto !important; bottom: 0 !important; }

.row-highlight-monthly-new {
  background-color: #fff3cd !important;
}
.row-highlight-monthly-new td {
  background-color: #fff3cd !important;
}

.pagination-wrapper {
  display: flex !important;
  justify-content: center !important;
  padding: 10px 0 4px 0 !important;
  flex-shrink: 0 !important;
}
.pagination-wrapper /deep/ .el-pagination { padding: 0 !important; }

/* ===== 关联模态框 ===== */
.association-container { max-height: 60vh !important; overflow-y: auto !important; }
.relation-header-container {
  background-color: #f5f7fa !important;
  padding: 5px 0 !important;
  font-weight: bold !important;
  border-bottom: 1px solid #ebeef5 !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 10 !important;
  width: 100% !important;
}
.relation-header-row { display: flex !important; width: 100% !important; }
.relation-header-cell { flex:1 !important; text-align:center !important; padding:0 5px !important; font-size:12px !important; color:#606266 !important; overflow:hidden !important; text-overflow:ellipsis !important; }
.relation-option-content { display: flex !important; width: 100% !important; padding: 3px 0 !important; }
.relation-data-cell { flex:1 !important; text-align:center !important; padding:0 5px !important; font-size:12px !important; color:#333 !important; overflow:hidden !important; text-overflow:ellipsis !important; border:1px solid #ccc !important; }

/* ===== 患者360弹窗样式 ===== */
.patient360-dialog {
  /deep/ .el-dialog {
    border-radius: 12px !important;
    overflow: hidden !important;
  }
  /deep/ .el-dialog__header {
    background-color: #2c4f79 !important;
    padding: 12px 20px !important;
    border-bottom: 1px solid #1f3a57 !important;
    border-radius: 8px 8px 0 0 !important;
  }
  /deep/ .el-dialog__title {
    font-size: 20px !important;
    font-weight: 600 !important;
    color: #ffffff !important;
  }
  /deep/ .el-dialog__header .el-dialog__close {
    color: #ffffff !important;
  }
  /deep/ .el-dialog__body {
    padding: 20px 24px !important;
    max-height: 75vh !important;
    overflow-y: auto !important;
    background: #f5f7fa !important;
  }
  .patient360-container {
    .info-card {
      background: #ffffff !important;
      border-radius: 8px !important;
      padding: 16px !important;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06) !important;
      height: 100% !important;
      transition: box-shadow 0.2s;
      display: flex !important;
      flex-direction: column !important;
      &:hover {
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      }
      .card-title {
        font-size: 14px !important;
        font-weight: 600 !important;
        color: #1d2129 !important;
        border-bottom: 1px solid #f0f0f0 !important;
        padding-bottom: 8px !important;
        margin-bottom: 12px !important;
        flex-shrink: 0 !important;
      }
      .card-content {
        font-size: 13px !important;
        color: #4e5969 !important;
        flex: 1 !important;
        display: flex !important;
        flex-direction: column !important;
        justify-content: center !important;
        .info-item {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          padding: 4px 0 !important;
          .label {
            color: #86909c !important;
            flex-shrink: 0;
            margin-right: 10px;
          }
          .value {
            font-weight: 500 !important;
            color: #1d2129 !important;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .address-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
          }
          .address-toggle {
            cursor: pointer;
            margin-left: 6px;
            color: #1677FF;
            font-size: 16px;
            flex-shrink: 0;
            &:hover {
              color: #0a5bbf;
            }
          }
        }
        .el-tag {
          margin: 2px 4px 2px 0;
        }
      }
      .chart-content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 120px;
        padding: 0;
        flex: 1 !important;
      }
      .timeline-horizontal {
        overflow-x: auto;
        padding: 8px 0;
        flex: 1 !important;
        .timeline-scroll {
          display: flex;
          align-items: flex-start;
          gap: 24px;
          padding-bottom: 8px;
          .timeline-node {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 0 0 auto;
            min-width: 120px;
            position: relative;
            .timeline-time {
              font-size: 12px;
              color: #86909c;
              margin-bottom: 6px;
              white-space: nowrap;
            }
            .timeline-dot {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #1677FF;
              margin-bottom: 6px;
              flex-shrink: 0;
            }
            .timeline-content-text {
              font-size: 13px;
              color: #4e5969;
              text-align: center;
              max-width: 150px;
              word-break: break-all;
            }
            &:not(:last-child)::after {
              content: '';
              position: absolute;
              top: 16px;
              left: calc(100% + 4px);
              width: 16px;
              height: 2px;
              background-color: #d9d9d9;
            }
          }
        }
      }
    }
    .timeline-card {
      .card-content {
        padding: 8px 0;
        justify-content: flex-start !important;
      }
    }
    .equal-height-card {
      min-height: 220px !important;
      height: 100% !important;
    }
  }
}

/* ===== 响应式 ===== */
@media screen and (max-width: 1400px) {
  .stat-card-value { font-size: 22px !important; }
}
@media screen and (max-width: 1200px) {
  .stat-card-value { font-size: 20px !important; }
  .middle-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .filter-row { flex-wrap: wrap !important; gap: 8px !important; }
  .search-group { margin-left: 0 !important; width: 100% !important; justify-content: flex-end !important; }
}
@media screen and (max-width: 768px) {
  .middle-grid {
    grid-template-columns: 1fr;
  }
  .bottom-right-grid {
    flex-direction: column;
    gap: 8px;
  }
  .bottom-sub-card {
    width: 100%;
  }
  .patient360-dialog /deep/ .el-dialog {
    width: 98% !important;
  }
  .stat-card-value { font-size: 20px !important; }
}
</style>